import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Arrow Left"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-arrow-left',
    templateUrl: './icon-arrow-left.component.html',
    styleUrls: ['./icon-arrow-left.component.scss'],
    standalone: false
})
export class IconArrowLeftComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;

}
